/**
 * A mapping of whether certain test features are enabled.
 */
export const ENABLED_FEATURES = {
  ARTIFACT_PROMPTS: false,
  ARTIFACT_NAME_CHECK: false,

  ACTIVE_USERS: false,
  TRACE_MATRIX_TABLE: false,

  ONBOARDING_PUBLIC_REPOS: false,

  GENERATE_SUMMARIES: false,
  HEALTH: false,
  SIGN_UP: true,
};
